// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IRenewalPlanYearDto
 */
export interface IRenewalPlanYearDto {
    /**
     * 
     * @type {string}
     * @memberof IRenewalPlanYearDto
     */
    name?: string;
    /**
     * 
     * @type {Date}
     * @memberof IRenewalPlanYearDto
     */
    valid_from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IRenewalPlanYearDto
     */
    valid_to?: Date;
    /**
     * 
     * @type {number}
     * @memberof IRenewalPlanYearDto
     */
    prior_plan_year_id?: number;
}

/**
 * Check if a given object implements the IRenewalPlanYearDto interface.
 */
export function instanceOfIRenewalPlanYearDto(value: object): value is IRenewalPlanYearDto {
    return true;
}

export function IRenewalPlanYearDtoFromJSON(json: any): IRenewalPlanYearDto {
    return IRenewalPlanYearDtoFromJSONTyped(json, false);
}

export function IRenewalPlanYearDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IRenewalPlanYearDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'valid_from': json['valid_from'] == null ? undefined : (new Date(json['valid_from'])),
        'valid_to': json['valid_to'] == null ? undefined : (new Date(json['valid_to'])),
        'prior_plan_year_id': json['prior_plan_year_id'] == null ? undefined : json['prior_plan_year_id'],
    };
}

export function IRenewalPlanYearDtoToJSON(json: any): IRenewalPlanYearDto {
    return IRenewalPlanYearDtoToJSONTyped(json, false);
}

export function IRenewalPlanYearDtoToJSONTyped(value?: IRenewalPlanYearDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'valid_from': value['valid_from'] == null ? undefined : ((value['valid_from']).toISOString().substring(0,10)),
        'valid_to': value['valid_to'] == null ? undefined : ((value['valid_to']).toISOString().substring(0,10)),
        'prior_plan_year_id': value['prior_plan_year_id'],
    };
}

